export enum TypeOfChange{
    create = 'create',
    edit = 'edit',
    restore = 'restore',
    delete = 'delete',
    move = 'move',
    changePassword = 'changePassword',
    invite = 'invite',
    archive = 'archive',
    unarchive = 'unarchive'
}

export enum EntityType {
    user = 'user',
    role = 'role',
    project = 'project',
    securitySettings = 'securitySettings',
    generalInformation = 'generalInformation',
    subProject = 'subProject',
    board = 'board',
    proxyBoard = 'proxyBoard',
    column = 'column',
    projectFile = 'projectFile',
    projectTeam  = 'projectTeam', 
    task = 'task',
    taskFile = 'taskFile',
    taskComment = 'taskComment',
    checkListComment = 'checkListComment'
}